import { Construction, Settings } from "@mui/icons-material";
import { IFeatures } from "../../utils/interfaces";

import { useSessionContext } from "../../contexts/SessionContext";
import { FluxExtensions } from "./FluxExtensions";

export function useFluxExtensions() {
  const { access } = useSessionContext();
  const configs: IFeatures = {
    active: access.type === "professional",
    path: "/extensions",
    icon: Construction,
    text: "Extensões do Fluxmed",
    sideMenu: true,
    sideMenuIndex: 6,

    component: () => <FluxExtensions />,
  };

  return configs;
}
